export default __webpack_public_path__ + "src/components/pages/login/customers/261cd069223fd46de7f9ce405c079d37.png";